import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { grantAnalyticsConsent, initAnalytics } from './utils/analytics';

// Boot GA4 / GTM (no-op when neither REACT_APP_GA4_MEASUREMENT_ID nor
// REACT_APP_GTM_CONTAINER_ID is set). Consent default is already
// `denied` from the inline script in public/index.html.
initAnalytics();

// Temporary opt-in escape hatch until the consent banner ships.
// Setting `REACT_APP_ANALYTICS_AUTO_GRANT=true` flips analytics_storage
// to `granted` immediately so data starts flowing — useful for
// validating measurement during development / soft-launch. Remove this
// flag once the proper consent UI lands (§8.4 of the GA4 guideline).
if (process.env.REACT_APP_ANALYTICS_AUTO_GRANT === 'true') {
  grantAnalyticsConsent();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
